import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ShowcaseHeader from 'Catalog/Showcase/ShowcaseHeader'

import { Bling as Slider } from 'react-gpt'

Slider.configure({
  renderWhenViewable: false,
  collapseEmptyDiv: true,
  outOfPage: true
})

class BannersShowcase extends Component {
  configureDfpTargeting (dfpAccount, sliders, campaignId, catalogId, clientId) {
    return sliders.map(slider => ({
      accountDfp: dfpAccount,
      sliderName: slider,
      urlSlider: '/' + dfpAccount + '/' + slider,
      sizeMapping: [
        { viewport: [0, 0], slot: [304, 224] },
        { viewport: [380, 0], slot: [380, 280] }
      ],
      targeting: {
        ltm_campaign: [campaignId, 'default'],
        ltm_catalog: [catalogId, 'default']
      }
    }))
  }
  removeEmpty = event => {
    if (event.isEmpty) {
      var list
      list = document.querySelectorAll('.banner-showcase-ordination')
      for (var i = 0; i < list.length; ++i) {
        list[i].classList.add('d-none')
      }
    }
  }
  render () {
    let { profile, google } = this.props

    const sliders = [
      'showcase_banner_1',
      'showcase_banner_2',
      'showcase_banner_3'
    ]
    const campaignId = profile ? profile['custom:campaign_id'] : '0'
    const catalogId = profile ? profile['custom:catalog_id'] : process.env.REACT_APP_CATALOG_ID
    const clientId = profile ? profile['custom:client_id'] : '0'

    const sliderList = this.configureDfpTargeting(google.accountDfp, sliders, campaignId, catalogId, clientId)

    return (
      <div className='banner-showcase-ordination container-fluid px-0'>
        <div className={`banners-showcase-container pos-relative py-3`}>

          <div className='container px-1 px-sm-0'>
            <ShowcaseHeader
              title={process.env.REACT_APP_HAS_BANNERS_SHOWCASE_TITLE}
              mobileTitle={process.env.REACT_APP_HAS_BANNERS_SHOWCASE_TITLE}
              viewAllPath={`/search`}
            />
            <div className='row'>
              { sliderList.map((itemSlider, index) => (
                <div key={index} className={`col-auto col-sm-4 mx-auto my-1 my-sm-0`}>
                  {<Slider
                    adUnitPath={itemSlider.urlSlider}
                    sizeMapping={itemSlider.sizeMapping}
                    targeting={itemSlider.targeting}
                    onSlotRenderEnded={this.removeEmpty}
                  />}
                </div>))}

            </div>
          </div>

        </div>
      </div>
    )
  }
}

BannersShowcase.propTypes = {
  profile: PropTypes.shape({
    'custom:campaign_id': PropTypes.string.isRequired,
    'custom:catalog_id': PropTypes.string.isRequired,
    'custom:client_id': PropTypes.string.isRequired
  }),
  google: PropTypes.shape({
    accountDfp: PropTypes.string.isRequired
  })
}

const mapStateToProps = ({ oidc: { user }, google }) => ({
  profile: user && user.profile,
  google
})

export default connect(mapStateToProps)(BannersShowcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/BannersShowcase.js